module.exports = __webpack_public_path__ + "img/3.34ad7e7e.png";